<template>
  <div class="card mt-3">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <h6 class="font-weight-bold m-0">
          Filter
        </h6>

        <a
          class="user-select-none"
          @click="expanded = !expanded"
        >
          <i
            class="fa fa-lg text-info"
            :class="{
              'fa-caret-up': expanded,
              'fa-caret-down': !expanded
            }"
          />
        </a>
      </div>

      <div v-show="expanded">
        <div class="row">
          <div class="col-12 col-md-3 mt-3">
            <h6>
              <small class="font-weight-bold">{{ $t('user-management.filter.label.employment-status') }}</small>
            </h6>
            <v-select
              v-model="filters.EmployeeType"
              class="sm"
              label="name"
              :placeholder="$t('user-management.filter.placeholder.employment-status')"
              :options="employeeTypes"
              :reduce="reducer"
              multiple
            />
          </div>
          <div class="col-12 col-md-3 mt-3">
            <h6>
              <small class="font-weight-bold">{{ $t('user-management.filter.label.hris-employee') }}</small>
            </h6>
            <toggle-button
              v-model="filters.IsHris"
              class="mt-1"
              color="#18B2BD"
              sync
            />
          </div>
          <div class="col-12 col-md-3 mt-3">
            <h6>
              <small class="font-weight-bold">{{ $t('user-management.filter.label.status') }}</small>
            </h6>
            <v-select
              v-model="filters.status"
              class="sm"
              label="name"
              :placeholder="$t('user-management.filter.placeholder.status')"
              :options="statuses"
              multiple
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-3 mt-3">
            <h6>
              <small class="font-weight-bold">{{ $t('user-management.filter.label.company') }}</small>
            </h6>
            <v-select
              v-model="filters.companyId"
              class="sm"
              label="name"
              :placeholder="$t('user-management.filter.placeholder.company')"
              :options="companies"
              :reduce="reducer"
              multiple
            />
          </div>
          <div class="col-12 col-md-3 mt-3">
            <h6>
              <small class="font-weight-bold">{{ $t('user-management.filter.label.organization') }}</small>
            </h6>
            <v-select
              v-model="filters.workLocationId"
              class="sm"
              label="name"
              :placeholder="$t('user-management.filter.placeholder.organization')"
              :options="workLocations"
              :reduce="reducer"
              :selectable="workLocationSelectable"
              multiple
            >
              <template #option="{ group, name }">
                <div v-if="group">
                  {{ group }}
                </div>
                {{ name }}
              </template>
            </v-select>
          </div>
          <div class="col-12 col-md-3 mt-3">
            <h6>
              <small class="font-weight-bold">{{ $t('user-management.filter.label.contractor') }}</small>
            </h6>
            <v-select
              v-model="filters.contractorId"
              class="sm"
              label="name"
              :placeholder="$t('user-management.filter.placeholder.contractor')"
              :options="contractors"
              :reduce="reducer"
              multiple
            />
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button
            class="btn btn-sm btn-info font-weight-bold"
            @click="$emit('apply')"
          >
            {{ $t('user-management.filter.apply') }}
          </button>
          <button
            class="btn btn-sm btn-outline-info ml-2 font-weight-bold"
            @click="$emit('reset')"
          >
            {{ $t('user-management.filter.reset') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { ToggleButton } from 'vue-js-toggle-button'
import api from '@/utils/Api'

const employeeTypes = [
  { id: 'AdUser', name: 'AD User' },
  { id: 'External', name: 'External' }
]

const statuses = [
  'Active',
  'Inactive'
]

export default {
  components: {
    VSelect,
    ToggleButton
  },

  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    expanded: true,
    companies: [],
    workLocations: [],
    contractors: [],
    employeeTypes,
    statuses
  }),

  created () {
    this.fetchCompanies()
    this.fetchContractors()
    this.fetchWorkLocations()
  },

  methods: {
    async fetchCompanies () {
      const { data } = await api.masterData.customCompanies()
      this.companies = data.data
    },
    async fetchContractors () {
      const { data } = await api.masterData.customContractors()
      this.contractors = data.data
    },
    async fetchWorkLocations () {
      const { data } = await api.masterData.customWorkLocations()
      this.workLocations = data.data.reduce((acc, curr) => {
        const newGroup = (!acc.find(a => a.group === curr.category) &&
          [{ group: curr.category, name: null }]) ||
          []
        return [
          ...acc,
          ...newGroup,
          curr
        ]
      }, [])
    },
    reducer: ({ id }) => id,
    workLocationSelectable: ({ group }) => !group
  }
}
</script>
